
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"text-bold"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 19h8.273c1.519 0 2.976-.569 4.05-1.582C16.396 16.406 17 15.032 17 13.6s-.603-2.806-1.678-3.818C14.25 8.769 12.793 8.2 11.273 8.2h.637a4.02 4.02 0 001.461-.274 3.84 3.84 0 001.239-.78c.354-.335.636-.732.828-1.168a3.422 3.422 0 000-2.756 3.592 3.592 0 00-.828-1.168 3.84 3.84 0 00-1.239-.78A4.02 4.02 0 0011.91 1H3m2.545 0v18m5.728-10.8H5.545","stroke":"currentColor","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    